export { default as FileDropzone } from './FileDropzone';
